import React from "react";
import BaseModal from "../../../../modals/BaseModal";
import ActionPlanProgress from "../../../../components/ActionPlanProgress";

function PlanGenerationModal({ currentStep, isComplete, isOpen, canStartPlan = true, onBack, onClose, onStartPlan }) {
  return (
    <BaseModal className="action-plan-generation-modal" isOpen={isOpen} onClose={onClose} showClose={false}>
      <div className="action-plan-generation">
        <ActionPlanProgress value={currentStep.progress} size="md" />
        <h4>Creating Your Plan</h4>
        <p>{currentStep.description}</p>
        {isComplete && (
          <div className="action-plan-generation__actions">
            <button type="button" className="action-plan-generation__btn action-plan-generation__btn--outline" onClick={onBack}>
              Back
            </button>
            <button
              type="button"
              className="action-plan-generation__btn action-plan-generation__btn--primary"
              onClick={onStartPlan}
              disabled={!canStartPlan}
            >
              Continue to my plan
            </button>
          </div>
        )}
      </div>
    </BaseModal>
  );
}

export default React.memo(PlanGenerationModal);
